import * as DM from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';

export type DropdownItem =
  | { type?: 'item'; label: ReactNode; onSelect: () => void; danger?: boolean; icon?: ReactNode }
  | { type: 'label'; label: ReactNode }
  | { type: 'separator' };

/** An accessible menu: arrow keys, typeahead, Escape to close. */
export function Dropdown({ trigger, items, align = 'end' }: { trigger: ReactNode; items: DropdownItem[]; align?: 'start' | 'end' }) {
  return (
    <DM.Root>
      <DM.Trigger asChild>{trigger}</DM.Trigger>
      <DM.Portal>
        <DM.Content className="ui-menu" align={align} sideOffset={6}>
          {items.map((item, i) => {
            if (item.type === 'separator') return <DM.Separator key={i} className="ui-menu-sep" />;
            if (item.type === 'label') return <DM.Label key={i} className="ui-menu-label">{item.label}</DM.Label>;
            return (
              <DM.Item key={i} className={`ui-menu-item ${item.danger ? 'danger' : ''}`} onSelect={item.onSelect}>
                {item.icon}
                {item.label}
              </DM.Item>
            );
          })}
        </DM.Content>
      </DM.Portal>
    </DM.Root>
  );
}
